import { createFileRoute } from '@tanstack/react-router';

import { GradesPage } from '@/features/teacher/GradesPage';

export const Route = createFileRoute('/_authed/teacher/grades')({
  validateSearch: (search): { group?: string; student?: string } => ({
    group: typeof search.group === 'string' ? search.group : undefined,
    student: typeof search.student === 'string' ? search.student : undefined,
  }),
  component: GradesPage,
});
